import { RESTORE_SAVED_LAUNCHER_POSITION } from '../constants/PostMessageTypes';
import { postMessageToParent } from './postMessageToParent';
export const handleRestoreSavedLauncherPosition = () => postMessageToParent(RESTORE_SAVED_LAUNCHER_POSITION, {});